<template>
    <div class="grid">
    <div class="col-12">
        <Card id="toolbar">
            <template #title>
                <Toolbar>
                    <template #right>
                        <div class="p-card-title" style="margin-top:10px;">
                            <Button label="Print" icon="pi pi-print pi-fw" class="p-button-success mr-2" @click="printWindow()" />
                            <Button v-if="this.$IS_PRINT_DOCUMENT == 'TRUE'" label="Pdf" icon="pi pi-file-pdf pi-fw" class="p-button-danger mr-2" @click="exportToPDF" />
                            <Button label="Back" icon="pi pi-chevron-left" class="p-button-primary"  @click="backToIndex" />
                        </div>
                    </template>
                </Toolbar>
            </template>
        </Card>
        <div class="surface-0">
            <div id="apps" class="center">
                <table class="table"  ref="document" style="font-family:'Times New Roman', Times, serif;font-size:12px;" v-if="dataDocument">
                    <tbody>
                         <tr style="text-align:center;height: 70px;">
                            <td style="width:20%;"> 
                                <!-- <img src="/assets/layout/images/wilmar-logo.png" width="150" height="50"/> -->
                             </td>
                            <td colspan="2" style="width:80%;"> 
                                <!-- <span class="title">{{dataDocument.company_name.toUpperCase()}}</span> -->
                            </td>
                        </tr>
                        <!-- <tr>
                            <td></td>
                            <td colspan="2"><p style="color:#8e8158e4;"><i><span class='subtitle'>{{"Excellent & Trustworthy"}}</span></i></p></td>
                        </tr> -->
                        <tr>
                            <td colspan="3"><p style="margin-left:50px;"><span>Kepada Yth.</span></p></td>
                        </tr>
                        <tr>
                            <td colspan="3"><p style="margin-left:50px;"><span>Bapak Pimpinan :</span></p></td>
                        </tr>
                        <tr>
                            <td colspan="3"><p style="margin-left:50px;"><b>{{ dataDocument.contractor }}</b></p></td>
                        </tr>
                        <tr>
                            <td colspan="3"><p style="margin-left:50px;"><span>Di Tempat</span></p></td>
                        </tr>
                       <tr class="th" style="text-align:center;">
                        <td colspan="3"><p style="font-size:20px"><u>SURAT PENALTY</u><br/>
                            <span style="font-size:15px;" v-if="dataDocument">No. Document: {{dataDocument.Doc_No}}</span></p></td>
                       </tr>
                        <tr>
                            <td colspan="3"><p align="justify" class="p1" style="font-size:12px;">
                                Berdasarkan <span style="font-weight:bold;color:black">{{ dataDocument.Doc_No  != null ? dataDocument.Doc_No : "" }} </span> 
                                terdapat <span style="font-weight:bold;color:black">{{ dataDocument.Reason }}</span> pekerjaan 
                                <span style="font-weight:bold;color:black">{{ dataDocument.contractor }}</span>
                                dengan perincian sebagai berikut:
                            </p>
                        </td>
                        </tr>
                        <!-- <tr>
                            <td colspan="3">
                                <table class="widht1">
                                    <tbody>
                                        <tr>
                                            <td style="width:20%;">Hari/Tanggal</td>
                                            <td>: {{dataDocument!=null ? this.$formatDate(dataDocument.Hari_Tgl_Input) : ""}}</td>
                                        </tr>
                                        <tr>
                                            <td>Perihal</td>
                                            <td>: Denda penalty dikarenakan {{dataDocument!=null ? dataDocument.Perihal : ""}}</td>
                                        </tr>
                                        <tr>
                                            <td>Lampiran</td>
                                            <td>: {{dataDocument!=null ? dataDocument.Lampiran : ""}} Lembar</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr> -->
                        <!-- <tr style="height:15px;">
                            <td colspan="3"></td>
                        </tr> -->
                        <!-- <tr>
                            <td colspan="3">
                                <div class="widht1">
                                    <p align="justify">Bersama ini memberitahukan kepada <span style="font-weight:bold;">{{dataDocument.contractor}}</span> sesuai dengan yang 
                                    tertera pada BA keterlambatan pekerjaan bahwa telah terjadi keterlambatan penyelesaian pekerjaan sebagai berikut:</p>
                                </div>
                            </td>
                        </tr> -->
                        <tr>
                            <td colspan="3">
                                <table class="widht1" style="border-collapse: collapse;">
                                    <tbody>
                                        <tr style="text-align:center;font-weight:bold;height:30px;">
                                            <td style="border: 1px solid black;background-color:rgb(200, 200, 200);" class="th">Judul Pekerjaan</td>
                                            <td style="border: 1px solid black;background-color:rgb(200, 200, 200);" class="th">SPO</td>
                                            <td style="border: 1px solid black;background-color:rgb(200, 200, 200);" class="th">SCHEDULE DATE</td>
                                            <td style="border: 1px solid black;background-color:rgb(200, 200, 200);" class="th">ACTUAL DATE</td>
                                            <td style="border: 1px solid black;background-color:rgb(200, 200, 200);" class="th">TOTAL HARI</td>
                                            <td style="border: 1px solid black;background-color:rgb(200, 200, 200);" class="th">JUMLAH HARI YANG DIKENAKAN DENDA</td>
                                        </tr> 
                
                                        <tr v-for="item in dataDocument.Details" :key="item.Id"  style="text-align:center;height:35px;">
                                            <td style="border: 1px solid black;">{{item.Judul_Pekerjaan}}</td>
                                            <td style="border: 1px solid black;">{{item.SPO!= null ? item.SPO : "-"}}</td>
                                            <td style="border: 1px solid black;">{{this.$formatDate(item.Sch_Date)}}</td>
                                            <td style="border: 1px solid black;">{{this.$formatDate(item.Act_Date)}}</td>
                                            <td style="border: 1px solid black;">{{item.Total_Days}}</td>
                                            <td style="border: 1px solid black;">{{dataDocument.Penalty_Days}}</td>
                                        </tr> 
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <div class="widht1">
                                    <p align="justify">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Sehubungan dengan {{ dataDocument.Reason }} tersebut, maka kami kenakan denda dengan perhitungan sebagai berikut: 
                                    </p>
                                </div>
                            </td>
                        </tr>
                        <td colspan="2">
                            <table class="widht1">
                                <tbody>
                                    <tr>
                                        <td>Total Nilai Kontrak</td>
                                        <td>:</td>
                                        <td>{{dataDocument.TotalNilaiKontrak}}</td>
                                    </tr>
                                    <tr>
                                        <td>Jumlah hari yang dikenakan denda</td>
                                        <td>:</td>
                                        <td>{{dataDocument.Penalty_Days}} Hari</td>
                                    </tr>
                                    <tr>
                                        <td>Persentase denda per hari</td>
                                        <td>:</td>
                                        <td>{{dataDocument.Penalty_Percentage}} permil (‰)</td>
                                    </tr>
                                    <tr>
                                        <td>Total Nilai Denda</td>
                                        <td>:</td>
                                        <td>{{dataDocument.TotalNilaiDenda}}</td>
                                    </tr>
                                    <tr>
                                        <td>Maksimum Nilai Denda (5% dari Total Nilai Kontrak)</td>
                                        <td>:</td>
                                        <td>{{dataDocument.MaksNilaiDenda}}</td>
                                    </tr>
                                    <tr>
                                        <td style="font-weight:bold;">Total Nilai Denda yang ditagihkan <span style="color:red;">*</span></td>
                                        <td>:</td>
                                        <td>{{dataDocument.FinalNilaiDenda}}</td>
                                    </tr>
                                    <tr style="font-size:10px;color:red;font-style: italic;">
                                        <td colspan="3"><span style="color:black;">*</span>Jika nilai denda > maksimum nilai denda, Total Nilai Denda yang ditagihkan = Maksimum nilai denda</td>
                                    </tr>
                                    <tr style="font-size:10px;color:red;font-style: italic;">
                                        <td colspan="3">Jika nilai denda &lt; maksimum nilai denda, Total Nilai Denda yang ditagihkan = Total nilai denda</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <tr style="height:8px;">
                            <td colspan="3"></td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <div class="widht1">
                                    <p align="justify">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Dengan Penalty tersebut akan langsung kami potongkan dalam tagihan progress 100% sesuai dengan kesepakatan dalam {{ (dataDocument.no_spk ? "SPK No. " + dataDocument.no_spk : "SPO No. " + dataDocument.No_SPO) }} </b>.<br/>
                                        Demikian surat penalty ini kami sampaikan. Atas perhatian dan kerjasamanya kami sampaikan terimakasih
                                    </p>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <table class="widht1">
                                    <tbody>
                                        <tr>
                                            <td colspan="2" style="width:40%">
                                                <div style="text-align:center;float:Left;">
                                                    <p> {{ dataDocument.location + ", "+this.$formatDate(dataDocument.Hari_Tgl_Input)}}<br/>
                                                        Hormat Kami,<br/>
                                                        {{ dataDocument.comp1 }}
                                                    </p> <div v-if="!dataDocument.Appr_Name1"><br/><br/><br/></div>
                                                    <p class="fontsign" v-if="dataDocument.Appr_Name1">
                                                        {{ dataDocument.Appr_Name1 }}
                                                    </p>
                                                    <span>{{this.$formatDateTime1(dataDocument.ApprDate1)}}</span>
                                                    <hr>
                                                    <p>
                                                       <span>{{dataDocument.Appr_As1}}</span>
                                                    </p> 
                                                    <!-- <p v-else>
                                                        
                                                     </p>  -->
                                                </div>

                                            </td>
                                            <!-- <td colspan="2" style="width:10%;">
                                                
                                            </td> -->
                                            <td colspan="2" style="width:40%">
                                                <div style="text-align:center;float:right;">
                                                    <p><br/><br/>
                                                        {{ dataDocument.comp2 }}
                                                    </p> <div v-if="!dataDocument.Appr_Name2"><br/><br/><br/></div>
                                                    <p class="fontsign" v-if="dataDocument.Appr_Name2">
                                                        {{ dataDocument.Appr_Name2 }}
                                                    </p>
                                                    <span>{{this.$formatDateTime1(dataDocument.ApprDate2)}}</span>
                                                    <hr>
                                                    <p>
                                                        <span>{{dataDocument.Appr_As2}}</span>
                                                    </p> 
                                                </div>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <!-- <tr style="height:120px;">
                            <td></td>
                        </tr> -->
                    <!-- <tr>
                        <td colspan="2"><br/><p align="center" class="p1" style="color: #8e8158e4;"><i><b>Certification ISO 9001:2000 (TUV Rheinland)</b></i></p></td>
                    </tr> -->
                    </tbody>
                    <tfoot>
                        <tr>
                            <!-- <td colspan="2" class="tdfoot">
                                <table class="tdfoot" style="color: #8e8158e4;font-size:8.9px;margin-top:10px; width: 80%;margin: auto;">
                                    <tbody>
                                        <tr>
                                            <td>Medan Office</td> 
                                            <td>:</td>
                                            <td>B & G Tower, L.t 7, L.t 8, L.t 9, Jl.Putri Hijau No. 10 Medan - 20111, Tel.(061) 41027777 (Hunting), Fax. (061) 4154891, 4145150</td>
                                        </tr>
                                        <tr>
                                            <td>Factory</td>
                                            <td>:</td>
                                            <td><span v-if="dataDocument">{{dataDocument.address}}</span></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td> -->
                        </tr>
                        <tr>
                            <td colspan="2" class="tdfoot">
                                <!-- margin-right:20px; -->
                                <img src="/assets/layout/images/stamp-draft.png" height="120" width="140" style="margin-top:-200px;float:right;" v-if="dataDocument.Status == this.$REQUEST_STATUS.DRAFT|| dataDocument.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || dataDocument.Status == this.$APPROVAL_STATUS.REVISED "/>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="tdfoot">
                                <VueQrcode :value="valueLink" style="width:85px;margin-top:-40px; float:right;"></VueQrcode>
                            </td>
                        </tr>
                        <tr colspan="2" v-if="dataDocument.is_aproved">
                            <td colspan="2">
                                <p style="font-size:10px;">
                                    <b>
                                        {{ 
                                          this.signBy(dataDocument)
                                        
                                        }}

                                    </b>
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 20px;">
                            <td style="border: none;"></td>
                        </tr>
                    </tfoot>
                </table>
            </div> 
        </div>
</div>
</div>

</template>

<script>
import html2pdf from 'html2pdf.js'

export default{
data(){
    return {

        listDoc : null,
        dataheader : null,
        title : "listdocuments",
        docvalidity : [],
        compCode : "",
        dataDocument:null,
        imgcontractor : "",
        valueLink :this.$store.getters.getUrlApp + this.$route.fullPath
    }
},
methods:{
    signBy(data){
        this.signby = `${this.$DOCUMENTFOOTER.APPROVED_GENERATED} (Document Print by ${this.$store.getters.getFullname} at ${this.$formatDateTime2(new Date())})`; 
        return this.signby;
    },  
    formatRupiah(number) {
    const formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });

    return formatter.format(number);
    },
    backToIndex(){
        if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
        else 
            this.$router.push({ path: "/BaPenalty/Index" });
    },

    printWindow() {
        this.addPagenumber();
        window.print();
        this.removePageNumbers();
    },
    addPagenumber(){
        let pageNumber = 1;
        var table = this.$refs.document;
        var scrollHeight = table.offsetHeight;
        var totalPages = Math.ceil(table.scrollHeight / 1123);
        for (let i = 0; i < totalPages; i++) {
            var pageNumberDiv = document.createElement("div");
            var pgNum = document.createTextNode("" + (i+1) + "/" + totalPages);
            pageNumberDiv.classList.add('page-number');
            pageNumberDiv.style.position = "absolute";
            pageNumberDiv.style.top = "calc((100% - 10mm) * "+ (i+1) + " + 20px)";
            pageNumberDiv.style.right = 0;
            pageNumberDiv.style.height = "12px";
            //pageNumberDiv.style.marginBlockStart = "30px"
            pageNumberDiv.appendChild(pgNum);
            document.body.appendChild(pageNumberDiv);
            
        }
    },
    removePageNumbers() {
        const pageNumberElements = document.querySelectorAll('.page-number');
        pageNumberElements.forEach(element => element.remove());
    },

    exportToPDF() {
        html2pdf(this.$refs.document, {
            margin: [1,1,1,1],
            filename: 'myfile.pdf',
            image: { type: 'jpeg', quality: 1},
            html2canvas: { scale: 4},
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },

        })
    },
    getData() {
            this.$emit('block-ui');
            let self = this;
            self.$axios.get(this.$API_URL + "BaPenalty/getDataDoc/" +  self.$route.query.id 
            ).then((response) => {
                var data = response.data.data;
                self.dataDocument = data.document;
                self.imgcontractor = data.imgcontractor;
                self.$emit('unblock-ui');
            
            }).catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: self.$DEFAULT_TIMER });
                    self.$emit('unblock-ui');
            });
        },
    },
    computed:{
    },   
    created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;
            this.getData();
        },
}
</script>
<style>
@page {
    size: A4 portrait;
}
@media print {
    #app .layout-wrapper .p-blockui-container .layout-topbar{
        display: none;
    }

    #app .layout-wrapper .p-blockui-container .layout-sidebar{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-footer{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-main-container{
        padding: 10px;
        margin: 0;
    }
}
@media screen and (max-width: 64em) {
    .p-sidebar-left.p-sidebar-lg,
    .p-sidebar-left.p-sidebar-md,
    .p-sidebar-right.p-sidebar-lg,
    .p-sidebar-right.p-sidebar-md {
        width: 20rem;
    }
}

#apps{
    width: 80%;
}

</style>
<style scoped>
@media print {
    tfoot {
      position: fixed;
      bottom: 0;
      width: auto;
    }
    .tdfoot{
        width: 700px;
    }

    #toolbar{
        display: none;
    }
    #display{
        display: none;
    }

    body{
      width: 100%;
      margin: 0 auto;
    }

    #apps{
        width: 100%;
        margin-top: -5px;
    }
    .table .subtitle{
        margin-left:345px;
    }

}
.subtitle{
    margin-left:345px;
}
.table {
    border-collapse: collapse;
    width: 100%;
    color: black;
}
.table .th {
    padding-top: 12px;
    padding-bottom: 12px;
}
  /* #f9f340*/
.table .center{
    text-align: center;
}

.ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 12px;
    margin-top:-10px;
}

hr{
    border-top: 1.5px dotted black;
    padding: 0.3px;
    border-bottom: 1.8px solid black;
    margin : 0 auto;
    width:110px;
}

#toolbar{
    max-height: 90px;
}

.title{
    font-size: 30px;
    color: #8e8158e4;
}
.year{
    margin-left: 290px;
}
.center{
    margin: auto;
}
.p1 {
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
    white-space: normal;
    font-size:14px;
  }
  .widht1{
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
  }
  .fontsign{
    font-family: 'Monotype Corsiva'
  }
</style>